module.exports = __webpack_public_path__ + "static/media/dropdownArrow.4ce9d606.svg";